import { applicantSection, otherAttachments } from "modules/ebiForms/common";
import { EEbiFormCategory, EEbiFormOffice, IEbiFormDefinition } from "modules/ebiForms/typings";

/**
 * B9. Wniosek o udostępnienie informacji publicznej — ustawa z 6.09.2001 r. o dostępie do informacji publicznej.
 * Brak wzoru ogólnopolskiego; układ jak wzór Gminy Wilków (zakres, sposób i forma udostępnienia, forma przekazania,
 * zastrzeżenie o opłacie z art. 15).
 */
const B9: IEbiFormDefinition = {
  code: "B9",
  version: 1,
  title: "Wniosek o udostępnienie informacji publicznej",
  category: EEbiFormCategory.General,
  office: EEbiFormOffice.Municipality,
  description: "Poproś o informację publiczną, której urząd nie opublikował w Biuletynie Informacji Publicznej.",
  keywords: ["informacja publiczna", "dostęp", "BIP", "udip"],
  organ: "Wójt / Burmistrz / Prezydent Miasta",
  legalBasis: "art. 2 ust. 1 i art. 10 ust. 1 ustawy z dnia 6 września 2001 r. o dostępie do informacji publicznej",
  request:
    "Na podstawie art. 2 ust. 1 ustawy z dnia 6 września 2001 r. o dostępie do informacji publicznej zwracam się z prośbą o udostępnienie informacji w zakresie wskazanym poniżej.",
  feeLabel: "bez opłaty",
  fee: "Bez opłaty. Urząd może pobrać opłatę odpowiadającą dodatkowym kosztom udostępnienia (art. 15).",
  deadlineLabel: "do 14 dni",
  deadline: "Bez zbędnej zwłoki, nie później niż w 14 dni (art. 13).",
  sections: [
    applicantSection(),
    {
      code: "zakres",
      title: "Zakres informacji",
      fields: [
        {
          code: "zakresInformacji",
          type: "textarea",
          label: "Proszę o udostępnienie informacji w następującym zakresie",
          required: true,
          maxLength: 10000,
          hint: "Opisz możliwie dokładnie, jakiej informacji potrzebujesz (np. dokument, okres, sprawa).",
        },
      ],
    },
    {
      code: "sposob",
      title: "Sposób i forma udostępnienia informacji",
      fields: [
        {
          code: "sposobUdostepnienia",
          type: "checkboxes",
          label: "Sposób udostępnienia",
          required: true,
          defaultValue: ["pliki"],
          options: [
            { value: "wglad", label: "dostęp do przeglądania informacji w urzędzie" },
            { value: "kserokopia", label: "kserokopia" },
            { value: "pliki", label: "pliki komputerowe" },
          ],
        },
        {
          code: "formaPrzekazania",
          type: "radio",
          label: "Forma przekazania informacji",
          required: true,
          defaultValue: "ebi",
          options: [
            { value: "ebi", label: "w Elektronicznym Biurze Interesanta" },
            { value: "email", label: "pocztą elektroniczną na adres" },
            { value: "poczta", label: "pocztą na adres" },
            { value: "osobiscie", label: "odbiór osobiście przez wnioskodawcę" },
          ],
        },
        {
          code: "emailPrzekazania",
          type: "email",
          label: "Adres e-mail do przekazania informacji",
          required: true,
          visibleWhen: { field: "formaPrzekazania", equals: "email" },
        },
        {
          code: "adresPrzekazania",
          type: "text",
          label: "Adres do przesłania informacji",
          hint: "Wypełnij, jeśli jest inny niż podany wyżej.",
          visibleWhen: { field: "formaPrzekazania", equals: "poczta" },
          maxLength: 300,
        },
        {
          code: "infoOplata",
          type: "info",
          label:
            "Urząd zastrzega prawo pobrania opłaty od informacji udostępnionych zgodnie z art. 15 ustawy o dostępie do informacji publicznej — o wysokości opłaty zostaniesz powiadomiony w ciągu 14 dni.",
        },
      ],
    },
  ],
  attachments: [otherAttachments()],
};

export default B9;
